import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Http } from "@status/codes";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import { FormsService } from "../../../Forms/services/FormService";
import FormCards from "../../../Forms/components/FormCards/FormCards.vue";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import { GroupTasks } from "../../models/GroupTasks";
import {
  FILTER_SEARCH_TASKS_PROFILE,
  PROFILE_CONSTANTS,
  TASKLIST_ID
} from "../../constants/ProfileConstants";
import { TaskService } from "@/modules/Tasks/services/TaskService";
import {
  TASK_CONSTANTS,
  TASK_ACCESS
} from "@/modules/Tasks/constants/TaskConstants";
import { FormsData } from "@/modules/Forms/models/FormsData";
import FilterSearch from "../FilterSearch/FilterSearch.vue";
import { SearchFilter } from "@/shared/models/SearchFilter";
import AssignTask from "../AssignTask/AssignTask.vue";
import { mapGetters } from "vuex";
import store from "@/store";
import {
  NAME_FINDERS,
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { SearchContextModal } from "@/shared/models/SearchContextModal";
import SearchOneFilter from "./../../../../shared/components/GenericSearchBar/components/SearchOneFilter/SearchOneFilter.vue";
import {
  ItemFilterObj,
  QueryFilter
} from "@/shared/components/GenericSearchBar/model/FilterOneItem";
import { ID_FILTER } from "@/shared/components/GenericSearchBar/constants/GenericSearchConstants";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { GO_TO_TOP } from "@/modules/Home/constants/HomeConstants";

@Component({
  name: "Tasks",
  components: {
    FormCards,
    EmptyState,
    ModalTemplate,
    ObservationModal,
    FilterSearch,
    SearchOneFilter,
    AssignTask
  },
  computed: {
    ...mapGetters({
      dataToLateralMenu: "getDataToLateralMenu",
      taskRefresh: "getTaskRefreshing",
      generalData: "getGeneralDataTasks"
    })
  }
})
export default class Tasks extends Vue {
  dataToLateralMenu!: MenuDataStructure;
  @Prop() private userId!: string;
  @Prop() private assigned!: boolean;
  @Prop() mainTask!: string;

  @Inject() formsService!: FormsService;
  @Inject() taskService!: TaskService;

  TASK_CONTEXTUAL_KEY = NAME_FINDERS.TASK_CONTEXTUAL;
  EMPTY_TEXT = PROFILE_CONSTANTS.EMPTY_TEXT_TASK;
  EMPTY_TITLE = PROFILE_CONSTANTS.EMPTY_TITLE_TASK;
  EMPTY_TEXT_FILTER = PROFILE_CONSTANTS.EMPTY_TEXT_TASK_FILTER;
  PENDING_TASKS = PROFILE_CONSTANTS.PENDING_TASKS_TEXT;
  cardClass = STYLE_CLASSES.CARD;

  empty = true;
  loaded = false;
  dialogAssign = false;
  idToDelete = "";
  tasksByRoles: GroupTasks = {};
  tasksList: FormsData[] = [];
  taskToAssign = {};

  generalData!: FormsData[];
  counter = 0;
  filterItems: SearchFilter[] = [
    {
      name: PROFILE_CONSTANTS.FILTER_NAMES_TAGS.TASKS[0],
      value: "",
      id: PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.SUB.CATEGORY,
      active: false
    },
    {
      name: PROFILE_CONSTANTS.FILTER_NAMES_TAGS.TASKS[2],
      value: "",
      id: PROFILE_CONSTANTS.CHOSEN_SERVICES.TASKS.SUB.TASKROLENAME,
      active: false
    }
  ];

  taskRefresh!: boolean;
  showGoTopBtn = false;
  TASKLIST_ID = TASKLIST_ID;
  GO_TO_TOP_BTN = GO_TO_TOP;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;

  dataToMainView = {};

  async mounted() {
    await this.getData();
  }

  @Watch("dataToLateralMenu")
  dataToLateralMenuHandler() {
    if (
      this.dataToLateralMenu.type === PANEL_INFO_CONSTANTS.TYPE.TASK &&
      this.dataToLateralMenu.action === PANEL_INFO_CONSTANTS.ACTION.REFRESH
    ) {
      this.getData();
    }
  }

  @Watch("taskRefresh")
  async taskRefreshData() {
    if (this.taskRefresh === true) {
      try {
        await this.getData();
        store.commit(STORE_CONSTANTS.TASK_REFRESH, false);
      } catch (error) {
        Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      }
    }
  }

  @Watch("userId")
  @Watch("assigned")
  async getData() {
    try {
      this.tasksByRoles = {};
      store.commit(STORE_CONSTANTS.GENERAL_DATA_TASKS, []);
      this.tasksList = [];
      const data = await this.formsService.userForms(this.userId);

      if (data.code == Http.Found && data.data !== undefined) {
        this.tasksList = data.data;
        store.commit(STORE_CONSTANTS.GENERAL_DATA_TASKS, data.data);

        this.itemFilter.listItemFilterObj!.category = this.listCategory;
        this.dataToMainView = {
          from: PANEL_INFO_CONSTANTS.FROM.PANEL,
          type: PANEL_INFO_CONSTANTS.TYPE.TASK,
          action: PANEL_INFO_CONSTANTS.ACTION.SHOW,
          data: {
            taskNumber: data.data.length
          }
        };

        store.commit(STORE_CONSTANTS.TO_MAIN_VIEW, this.dataToMainView);

        this.empty = false;
      } else {
        if (data.code !== Http.NotFound) {
          Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
        }
        this.empty = true;
      }
      this.loaded = true;
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST} ${TASK_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      return;
    }
  }

  async disableTask() {
    try {
      const responseData = await this.taskService.deleteTask(this.idToDelete);

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(TASK_CONSTANTS.TASK_SNACKBAR.TASK_DELETED);
        this.getData();
      } else {
        Snackbar.popError(TASK_CONSTANTS.TASK_SNACKBAR.ERROR_DISABLING);
      }
    } catch (error) {
      Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  sendDataToLateralMenu(action: string, data?: any) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  deleteTask(id: string, taskName: string) {
    this.idToDelete = id;
    this.callDeleteModal(COMPONENT_NAME_MODAL.TASK, taskName);
  }

  callDeleteModal(actionCancel: string, taskName: string) {
    const modalUserTemplate: SearchContextModal = {
      componentName: actionCancel,
      itemName: taskName,
      callbackHandleOperation: this.handleOperation
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.MODAL_DELETE,
      modalUserTemplate
    );
  }

  async handleOperation(action: string) {
    switch (action) {
      case LIST_DATA_EVENTS.DELETE_DATA:
        await this.disableTask();
        break;
    }
  }

  itemFilter = {
    ...FILTER_SEARCH_TASKS_PROFILE
  };

  selectItem(item: ItemFilterObj) {
    if (!item || !item.name) {
      this.filtern = {};
      return;
    }
    this.filtern = { category: item.name };
  }

  filterOut(filter: QueryFilter) {
    this.filtern = filter;
  }

  get listCategory(): ItemFilterObj[] {
    return (
      this.generalData?.map(form => ({
        id: form.formTemplate.category,
        name: form.formTemplate.category
      })) ?? []
    );
  }
  filtern: QueryFilter = {};

  @Watch("generalData")
  changeGeneralData() {
    if (this.generalData.length > 0) this.empty = false;
  }

  get ListActual() {
    const filterKeys = Object.keys(this.filtern);
    if (filterKeys.length == 0) {
      return this.generalData;
    }
    const filterText = this.filtern[filterKeys[0]]?.toUpperCase();
    if (!filterText) {
      return this.generalData;
    }
    const filterKey = filterKeys[0];
    return (
      this.generalData?.filter(item => {
        if (filterKey == ID_FILTER.NAME) {
          return item.formTemplate.name?.toUpperCase().includes(filterText);
        }
        if (filterKey == ID_FILTER.CATEGORY) {
          return item.formTemplate.category?.toUpperCase() == filterText;
        }
      }) ?? []
    );
  }

  changeServices(tasksFiltered: FormsData[]) {
    if (tasksFiltered) {
      this.tasksList = tasksFiltered;
      this.counter++;
    }
  }

  assignedUser(task: FormsData) {
    this.taskToAssign = task;
    this.dialogAssign = true;
  }

  closeAssignModal(refresh: boolean) {
    if (refresh) this.getData();
    this.dialogAssign = false;
  }
  onScroll(event: Event) {
    const target = event.target as HTMLElement;
    this.showGoTopBtn = target.scrollTop >= 100;
  }

  goToTop() {
    const target = document.getElementById(this.TASKLIST_ID);
    if (target) {
      target.scrollTop = 0;
      this.showGoTopBtn = false;
    }
  }
}
